<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DxButton from 'devextreme-vue/button';
import { DxSwitch } from 'devextreme-vue/switch';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import ArrayStore from 'devextreme/data/array_store';

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxSummary,
  DxTotalItem,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout, PageHeader, DxButton, DxSwitch,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport, DxSummary,
    DxTotalItem, DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader

  },
  data() {

    return {
      title: "Notas Fiscais (Status)",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Notas Fiscais (Status)",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      showModalPeriodo: false,
      submittedPeriodo: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      updating: true,
      exibEmit: true,
      exibDest: true,

    };
  },

  created() {
    this.dtIniFiltro = moment().startOf('month').format('YYYY-MM-DD'); //Recuperando primeiro dia do mês
    this.dtFimFiltro = moment().endOf('day').format('YYYY-MM-DD'); //Recuperando data atual
    window.addEventListener("scroll", this.windowScroll);
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    abrirMov(){
      console.log('abrirMov')
      this.$router.push(`/movimentos/listnova`)


    },


    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    novoMov(){
      console.log('novoMov')
      this.$router.push(`/movimento/importar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/tracking/detalhe/${idData}`)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {

          // console.log('onCellPrepared')
          // console.log(e.data.mov_status)
          const valStatus = e.data.mov_status

          let corStatus = 'rgba(78,59,0,0.5)'

          switch (valStatus) {
            case 'AAG':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'EAG':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
          }



          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },

    atualizaDataList(){
      console.log('atualizaDataList')
      this.updating = true

      console.log(this.dtIniFiltro)
      console.log(this.dtFimFiltro)

      api.get(`${getBaseUrl()}api/movsstatus`,{
        params: {
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro,
          'ee': this.exibEmit,
          'ed': this.exibDest
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)

        this.dataList = new ArrayStore({
          key: 'mov_id',
          data: response.data[0],
        })
        this.totalList = response.data[1]

        this.updating = false
        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

        this.title = `(${this.totalList}) Notas Fiscais (Status): ${dtIniFormated} - ${dtFimFormated}`
      })
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.$refs.dataGridRefKey.instance.state(null);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'AAG':
          return 'AGUARDANDO AGENDAMENTO'
        case 'EL':
          return 'Elaboração'
        case 'CF':
          return 'Pedido Conferido'
        case 'EAG':
          return 'Entrega Agendada'
        case 'ENP':
          return 'Entregue no Prazo'
        case 'ECR':
          return 'Entregue com Ressalva'
        case 'EAT':
          return 'Entregue com Atraso'
        case 'SCT':
          return 'Sem CTe'
        case 'CCT':
          return 'Com CTe'
        case 'NEP':
          return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Fora do Prazo (Não Entregue)'

      }

      return 'Não Definido'
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="increaselinespacing"
              hint="Notas Fiscais"
              :on-click="abrirMov"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Nova Nota Fiscal"
              :on-click="novoMov"/>
        </DxItem>


        <DxItem
            location="after"
            widget="dxButton">
          <DxSwitch
              v-model:value="exibEmit"
              switchedOnText="Exibe Emitente"
              switchedOffText="Oculta Emitente"
              width="100px"
              @value-changed="mudouExib"
              :disabled="false"/>
        </DxItem>

        <DxItem
            location="after"
            widget="dxSwitch">
          <DxSwitch
              v-model:value="exibDest"
              switchedOnText="Exibe Destinatário"
              switchedOffText="Oculta Destinatário"
              width="100px"
              @value-changed="mudouExib"
              :disabled="false"/>
        </DxItem>



      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid

          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="false"
            :paging="false"
            :sorting="false"
            :summary="false"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovStatus"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="mov_id"
            caption="ID"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="mov_status"
            caption="Situação"
            alignment="left"
            :customize-text="nomeStatus"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>


        <DxColumn
            :width="100"
            data-field="mov_dtpreventr"
            caption="Previsão"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="mov_codigo"
            caption="NF"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="mov_ocorrencia"
            alignment="left"
            caption="Status"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="mov_data"
            alignment="right"
            caption="Data Última Ocorrência"
            data-type="datetime"
            format="dd/MM/yyyy HH:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>


        <DxColumn
            data-field="mov_cidade"
            alignment="left"
            caption="Cidade Ocorrência"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="mov_descricao"
            alignment="left"
            caption="Ocorrência"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>



        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="petransp_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="petransp_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="petransp_cidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="petransp_estado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>



        <DxSummary>

          <DxTotalItem
              column="OrderNumber"
              summary-type="count"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="min"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="max"/>


          <DxTotalItem
              column="SaleAmount"
              summary-type="sum"
              value-format="currency"/>

        </DxSummary>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>
